import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {MinimumPriceCardComponent} from './minimum-price-card/minimum-price-card.component'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {PriceRangeInfoComponent} from './price-range-contains-unknown/price-range-info.component'
import {ClientPriceRangeCardComponent} from './client-price-range-card/client-price-range-card.component'
import {PriceBreakdownComponent} from './price-breakdown/price-breakdown.component'
import {PipesModule} from '../../shared/pipes/pipes.module'
import {ChipComponent} from '../chip/chip.component'
import {DynamicIconModule} from '../dynamic-icon/dynamic-icon.module'
import {I18nDirective} from '../i18n/i18n.directive'
import {MinimumPriceComponent} from './minimum-price-card/minimum-price.component'

@NgModule({
  declarations: [
    MinimumPriceCardComponent,
    PriceRangeInfoComponent,
    ClientPriceRangeCardComponent,
    PriceBreakdownComponent,
  ],
  exports: [MinimumPriceCardComponent, PriceRangeInfoComponent, ClientPriceRangeCardComponent, PriceBreakdownComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    PipesModule,
    ChipComponent,
    DynamicIconModule,
    I18nDirective,
    MinimumPriceComponent,
  ],
})
export class PriceEstimationModule {}
